import React from "react";
import StarRating from "../star-rating/star-rating";
import ProductImageSlider from "./ProductImageSlider";
import { FaStar } from "react-icons/fa";

const ProductHeaderCard = ({ product }) => {
  const hasReview = (product?.reviews?.length || 0) > 0;
  const soldAmount = product?.product_sold_amount || 0;

  return (
    <section className="pdp-hero-card">
      <div className="pdp-hero-media">
        <ProductImageSlider images={product?.product_imgs || []} />
      </div>

      <div className="pdp-hero-body">
        <h1 className="pdp-hero-title">{product?.product_name}</h1>

        <div className="pdp-hero-meta">
          {hasReview ? (
            <StarRating rating={product?.averageRating} />
          ) : (
            <p className="pdp-hero-rating-empty">
              <FaStar className="pdp-hero-rating-empty-icon" />
              Chưa có đánh giá
            </p>
          )}
          <p className="pdp-hero-sold">{soldAmount > 0 ? `Mới` : "Mới"}</p>
        </div>

        <div className="pdp-description-block">
          <h3 className="pdp-description-title">Mô tả</h3>
          <p className="pdp-description-content">
            {product?.product_description?.split("\\n").join("\n") || "Chưa có mô tả."}
          </p>
        </div>
      </div>
    </section>
  );
};

export default ProductHeaderCard;
